import React from "react";
import Api from '../../services/api'
import "./TableList.css";

const RowList = ({data,onClick,machineTrackList}) => {
  let keys = Object.keys(data);
  keys.map((key, index) => {
    if(Array.isArray(data[key])){
      let aux = "";
      data[key].forEach((element)=>{
        aux = aux + element + " "
      });
      data[key] = aux;
    }
  });

  return (
    <tr onClick={(e) => onClick(data["id"])} key={data.id}>
      {machineTrackList
        ? keys.map((key, index) =>
            index === 0 ? (
              <td onClick={(e) => onClick(e.target.value)} key={key}>{data[key]}</td>
            ) : (
              <td>
                <input />
              </td>
            )
          )
        : keys.map((key) => <td style={{display: key == "id" ? `none` : null}} key={key}>{data[key]}</td>)}
    </tr>
  );
};

class TableList extends React.Component {

  state = { data: this.props.data,compVal:null,objEdit:{}, keys: [],id:0 };
  
  deleteValue = (id) =>{
    Api.delete(`/work-shifts/alt-day/${this.state.id}`).then(()=>{
      return window.location.reload()
    }).catch(err=>{
    
    });
  }
  rowClick = (value) => {
    this.setState({compVal:value});
    const result = this.state.data.find(v => v[`${this.props.compValue}`] == value);
    this.setState({id:result.id});
    if(this.props.compValue == 'id'){
      this.setState({objEdit:result},()=>{
        if (confirm("Deseja deleta esse registro ?")) {
          this.deleteValue();
        } else {
          
        }
      });
    }
    
  }
  render() {
    let { keys } = this.state;
   
    if (this.state.data.length > 0){
      keys = Object.keys(this.state.data[0]);
    }

    return (
      <div className="table-container">
        <table>
          <thead>
            <tr>
              {keys.map((item) => (
                <th
                  style={{position: 'sticky', top: 0, background: "white",display: item == "id" ? `none` : null }}
                  key={item}
                >
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {this.state.data.map((data, index) => (
              <RowList
                data={data}
                key={index}
                onClick={this.rowClick}
                machineTrackList={this.props.machineTrackList}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default TableList;